import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import PerilakuKerja from 'app/KinerjaPenilikPegawaiPage/pages/Perencanaan/PerilakuKerja'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import PageGuardPenilikPegawai from 'app/KinerjaPenilikPegawaiPage/components/PageGuardPenilikPegawai'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-penilik-pegawai-enabled'] || false
    const enabledPerencanaan =
      toggle?.['kinerja-penilik-pegawai-perencanaan-enabled'] || false

    if (!enabled || !enabledPerencanaan) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = (props: PageProps) => (
  <PageGuardPenilikPegawai>
    <PerilakuKerja {...props} />
  </PageGuardPenilikPegawai>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
  pageTitle: 'Pengelolaan Kinerja Penilik - Perencanaan - Perilaku Kerja',
}

export default Page
